module.exports = __webpack_public_path__ + "img/flag_fr.f18ac604.svg";